import { Service, service, inject } from './di'
import { ConfigService } from './ConfigService'
import { LocationService } from './LocationService'
import { FlyerService } from './FlyerService'

@service('BlackFridayService')
export class BlackFridayService extends Service {
    @inject config: ConfigService
    @inject location: LocationService
    @inject flyerService: FlyerService

    isEnabled() {
        return this.config.IS_BLACKFRIDAY === 'true'
    }

    isOnHost() {
        return (
            location.href.includes('/black-friday') ||
            location.href.includes('/vendredi-fou') ||
            location.href.includes('/cyber-week') ||
            location.href.includes('/semaine-cyber')
        )
    }

    getHostLink(category: string) {
        const name =
            this.location.locale === 'fr-ca'
                ? 'circulaires'
                : this.location.locale === 'en-us'
                  ? 'weekly_ads'
                  : 'flyers'
        let path = `${this.location.locale}/${name}/${category}?postal_code=${this.location.postalCode}`
        const currentSearchParams = new URLSearchParams(window.location.search)
        if (currentSearchParams.has('forceCyberWeek')) {
            path = path + '&forceCyberWeek'
        }
        return path
    }

    redirectToHost(category: string) {
        window.location.href = this.getHostLink(category)
    }
}
